import { render, staticRenderFns } from "./h5Player.vue?vue&type=template&id=b4e55f88&scoped=true"
import script from "./h5Player.vue?vue&type=script&lang=js"
export * from "./h5Player.vue?vue&type=script&lang=js"
import style0 from "./h5Player.vue?vue&type=style&index=0&id=b4e55f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e55f88",
  null
  
)

export default component.exports